import React from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';

const ExperienceStorySection = ({ section, sectionKey, sectionIndex, sectionTabs, renderHtmlTextBlock, renderPositionableElement }) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';
  const leadContent = sectionTabs[0] || { title: '', content: '' };

  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 }, width: '100%' }}>
      <Box sx={{ display: 'grid', gap: { xs: 1.5, md: 2.8 }, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, alignItems: 'center' }}>
        {renderPositionableElement({
          section, index: sectionIndex, elementKey: `${sectionKey}-experience-image`,
          children: section.image ? (
            <Box sx={{ borderRadius: '32px', overflow: 'hidden', boxShadow: `0 24px 48px ${alpha('#0F172A', 0.1)}`, aspectRatio: { xs: '4/3', md: '3/4' }, border: `8px solid #FFFFFF` }}>
              <Box component="img" src={section.image} alt={section.title || ''} sx={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: section.imageObjectPosition || 'center' }} />
            </Box>
          ) : (
            <Box sx={{ aspectRatio: '3/4', display: 'grid', placeItems: 'center', borderRadius: '32px', border: '2px dashed #CBD5E1', backgroundColor: '#F8FAFC' }}>
              <Typography sx={{ color: '#94A3B8', fontWeight: 700 }}>Add image</Typography>
            </Box>
          ),
        })}
        <Box>
          <Stack spacing={3}>
            {section.title && <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '2rem', md: '2.5rem' }, lineHeight: 1.1, letterSpacing: '-0.02em' }}>{section.title}</Typography>}
            {section.body && renderPositionableElement({
              section, index: sectionIndex, elementKey: `${sectionKey}-experience-body`,
              children: renderHtmlTextBlock(section.body, { color: bodyColor, lineHeight: 1.8, fontSize: '1.1rem' })
            })}
            {(leadContent.title || leadContent.content) && (
              <Box sx={{ mt: 2, p: 4, borderRadius: '6px', backgroundColor: alpha(accent, 0.04), border: `1px solid ${alpha(accent, 0.1)}`, borderLeft: `6px solid ${accent}` }}>
                {leadContent.title && <Typography sx={{ color: '#0F172A', fontWeight: 800, fontSize: '1.15rem', mb: 1 }}>{leadContent.title}</Typography>}
                {leadContent.content && renderHtmlTextBlock(leadContent.content, { color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' })}
              </Box>
            )}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
export default ExperienceStorySection;
